var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$route.name == 'login')?_c('div',[_c('SiteHeader'),_vm._v(" "),_c('router-view')],1):_c('div',[_c('SiteHeader'),_vm._v(" "),_c('BreadCrumb'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('SiteFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36056821","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Default.vue
// module id = null
// module chunks = 